









import { Component, Vue } from 'vue-property-decorator'
import { ReferralCount } from '@/api/types'
import { DoughnutChart } from 'vue-chart-3'
import { Chart, ChartData, ChartOptions, DoughnutController, ArcElement, ChartEvent, LegendItem, LegendElement, ActiveElement } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')
Chart.register(DoughnutController, ArcElement)

@Component({
    components: {
        DoughnutChart,
    },
})
export default class LegacyChartReferralScore extends Vue {
    @referrals.State readonly referralCounts!: ReferralCount
    @referrals.State readonly scoreFilter!: number[]
    @referrals.Action applyScoreFilter: ({ scoreFilter: [] }) => Promise<void>

    onChartRender(chart: Chart) {
        // @ts-ignore
        const legendItems = chart.legend.legendItems
        legendItems.forEach((item, index) => {
            const key = Number.parseInt(Object.keys(this.chartValues)[index], 10)
            item.hidden = this.scoreFilter.length > 0 && !this.scoreFilter.includes(key)
        })
    }

    get chartData(): ChartData {
        if (!this.chartValues) {
            return null
        }

        return {
            labels: this.chartLabels,
            datasets: [
                {
                    data: Object.values(this.chartValues),
                    backgroundColor: this.chartColors,
                    datalabels: {
                        color: 'rgba(255, 255, 255, .75)',
                    },
                },
            ],
        }
    }

    get chartOptions(): ChartOptions<'doughnut'> {
        return {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 4,
            animation: {
                easing: 'easeOutExpo',
            },
            plugins: {
                legend: {
                    position: 'right',
                    onClick: (e: ChartEvent, legendItem: LegendItem, legend: LegendElement) => {
                        // @ts-ignore type defines datasetIndex but it is index at runtime
                        this.onClick(legendItem.index)
                    },
                },
                tooltip: {
                    enabled: false,
                },
            },
            onClick: (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
                if (elements.length === 0) {
                    return
                }

                this.onClick(elements[0].index)
            },
        }
    }

    get chartPlugins(): object[] {
        return [
            ChartDataLabels,
        ]
    }

    get chartValues(): {[key: string]: number} {
        if (!this.referralCounts) {
            return {}
        }

        const chartValues = {
            '01': this.referralCounts.scorePositive,
            '00': this.referralCounts.scoreNeutral,
            '-01': this.referralCounts.scoreNegative,
        }

        return chartValues
    }

    get chartLabels(): string[] {
        const labels = {
            '01': 'Positief',
            '00': 'Neutraal',
            '-01': 'Negatief',
        }

        const chartLabels = []
        Object.keys(this.chartValues).forEach(key => {
            const label = labels[key]
            chartLabels.push(`${label} (${this.chartValues[key]})`)
        })

        return chartLabels
    }

    get chartColors(): string[] {
        const colors = {
            '01': 'rgb(0, 163, 137)',
            '00': 'rgb(236,201,75)',
            '-01': 'rgb(222, 64, 119)',
        }

        const chartColors = []
        Object.keys(this.chartValues).forEach(key => {
            const color = colors[key]
            chartColors.push(color)
        })

        return chartColors
    }

    onClick(selectedIndex: number): void {
        const selectedKey = Number.parseInt(Object.keys(this.chartValues)[selectedIndex], 10)

        let scoreFilter = [].concat(this.scoreFilter)
        if (!scoreFilter.includes(selectedKey)) {
            scoreFilter = [selectedKey]
        } else {
            scoreFilter = []
        }

        this.applyScoreFilter({ scoreFilter })
    }
}
